import { Inject, Injectable, OpaqueToken } from "@angular/core";
import { Headers, Http, Request, RequestMethod, RequestOptions } from "@angular/http";
import { AuthService } from "../auth/auth.service";
import { Observable } from "rxjs";
import { VersionService } from "../versioning/version.service";
/**
 * JwtHttpClientService is a wrapper over Angular Http. It appends JWT header for authentication.
 */
export class JwtHttpClientService {
    constructor(http, authService, versionService, httpTimeout) {
        this.http = http;
        this.authService = authService;
        this.versionService = versionService;
        this.httpTimeout = httpTimeout;
    }
    get(url, options) {
        return this._request(RequestMethod.Get, url, null, options);
    }
    getWithoutToken(url, options) {
        let requestOptions = new RequestOptions(Object.assign({
            method: RequestMethod.Get,
            url: this.authService.dataserverURL + url,
            body: null
        }, options));
        if (!requestOptions.headers) {
            requestOptions.headers = new Headers();
        }
        this.versionService.setVersionHeader(requestOptions.headers);
        let request = this.http.request(new Request(requestOptions));
        return request.catch(initialError => {
            if (initialError && initialError.status === 406) {
                this.versionService.requireVersions(initialError.text());
                return Observable.throw(initialError);
            }
            else {
                return Observable.throw(initialError);
            }
        });
    }
    post(url, body, options) {
        return this._request(RequestMethod.Post, url, body, options);
    }
    put(url, body, options) {
        return this._request(RequestMethod.Put, url, body, options);
    }
    delete(url, options) {
        return this._request(RequestMethod.Delete, url, null, options);
    }
    patch(url, body, options) {
        return this._request(RequestMethod.Patch, url, body, options);
    }
    head(url, options) {
        return this._request(RequestMethod.Head, url, null, options);
    }
    _request(method, url, body, options) {
        let requestOptions = new RequestOptions(Object.assign({
            method: method,
            url: url,
            body: body
        }, options));
        if (!requestOptions.headers) {
            requestOptions.headers = new Headers();
        }
        this.authService.setAuthorizationAndLocationHeaders(requestOptions.headers);
        this.versionService.setVersionHeader(requestOptions.headers);
        if (this.authService.isAccessTokenExpired()) {
            //console.log("Access Token Expired (client side detected)");
            return this.authService.refreshAccessToken()
                .flatMap((result) => {
                if (result == true) {
                    this.authService.setAuthorizationAndLocationHeaders(requestOptions.headers);
                    //console.log("Re-Performing request after token refresh ... ");
                    return this.performRequest(requestOptions);
                }
            });
        }
        else {
            return this.performRequest(requestOptions);
        }
    }
    performRequest(requestOptions) {
        if (!requestOptions.url || (!requestOptions.url.startsWith("http:") && !requestOptions.url.startsWith("https:"))) {
            requestOptions.url = this.authService.dataserverURL + requestOptions.url;
        }
        let request = this.http.request(new Request(requestOptions));
        if (this.httpTimeout) {
            request = request.timeout(this.httpTimeout);
        }
        return request.catch(initialError => {
            if (initialError && initialError.status === 401) {
                //console.log("Access Token Expired (server side detection");
                //token might be expired, attempt refresh token
                return this.authService.refreshAccessToken()
                    .flatMap((result) => {
                    if (result == true) {
                        this.authService.setAuthorizationAndLocationHeaders(requestOptions.headers);
                        //console.log("Re-Performing request after token refresh (server side detected) ... ");
                        return this.http.request(new Request(requestOptions));
                    }
                    return Observable.throw(initialError);
                });
            }
            else if (initialError && initialError.status === 406) {
                this.versionService.requireVersions(initialError.text());
                return Observable.throw(initialError);
            }
            else {
                return Observable.throw(initialError);
            }
        });
    }
}
/**
 * Token for injected http timeout value
 * @type {OpaqueToken}
 */
JwtHttpClientService.HTTP_TIMEOUT_KEY = new OpaqueToken('httpTimeout');
JwtHttpClientService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
JwtHttpClientService.ctorParameters = () => [
    { type: Http, },
    { type: AuthService, },
    { type: VersionService, },
    { type: undefined, decorators: [{ type: Inject, args: [JwtHttpClientService.HTTP_TIMEOUT_KEY,] },] },
];
//# sourceMappingURL=jwt-http-client.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/http/jwt-http-client.service.js
// module id = 29
// module chunks = 1